import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import useAuthToken from "../../hooks/useAuthToken";
import { getProfile } from "../../api/auth";
import { useLanguage } from "../../context/LanguageContext";

const RequireAuth = ({ children }) => {
  const { t } = useLanguage();
  const { isAuthenticated, logout } = useAuthToken();
  const location = useLocation();
  const [status, setStatus] = useState(isAuthenticated ? "checking" : "no-session");

  useEffect(() => {
    if (!isAuthenticated) {
      setStatus("no-session");
      return;
    }

    let cancelled = false;

    const verify = async () => {
      try {
        await getProfile();
        if (!cancelled) setStatus("ok");
      } catch {
        await logout();
        if (!cancelled) setStatus("no-session");
      }
    };

    verify();

    return () => {
      cancelled = true;
    };
  }, [isAuthenticated, logout]);

  if (status === "checking") {
    return <div className="auth-loading">{t("auth.loading.checkingSession", "Checking your session...")}</div>;
  }

  if (status === "no-session") {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
};

export default RequireAuth;
